// Angular
import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
// Routing
import { SubjectsRoutingModule } from './subjects-routing.module';
// Modules
import { MedsurfViewerCommonModule } from '../common/medsurf-viewer-common.module';
// Components
import { CarouselComponent } from './carousel/carousel.component';
import { SubjectsComponent } from './subjects.component';

/**
 * Subjects Module
 */
@NgModule({
  imports: [
    // Angular
    CommonModule,
    NgOptimizedImage,
    RouterModule,
    // Routing
    SubjectsRoutingModule,
    // Modules
    MedsurfViewerCommonModule,
  ],
  declarations: [
    // Components
    CarouselComponent,
    SubjectsComponent,
  ],
})
export class SubjectsModule { }
